import { styled } from "@l2r-front/l2r-ui"

export const PageContainer = styled("div")(() => ({
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}))